import { render, staticRenderFns } from "./RatePolicy.vue?vue&type=template&id=43f6c283&scoped=true&"
import script from "./RatePolicy.vue?vue&type=script&lang=js&"
export * from "./RatePolicy.vue?vue&type=script&lang=js&"
import style0 from "./RatePolicy.vue?vue&type=style&index=0&id=43f6c283&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f6c283",
  null
  
)

export default component.exports